import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { Button } from "./ui/button";
import { platforms, featuredResources } from "../data/mock";

const Sidebar = ({ selected, setSelected, onCompare }) => {
  const setSlot = (idx, value) => {
    const next = [...selected];
    next[idx] = value;
    setSelected(next);
  };

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-5">
        <h3 className="font-bold text-[#111827] mb-1">Compare Platforms</h3>
        <p className="text-xs text-slate-500 mb-4">Select up to 3 platforms to compare side by side</p>
        <div className="space-y-3">
          {[0, 1, 2].map((idx) => (
            <Select key={idx} value={selected[idx] || ""} onValueChange={(v) => setSlot(idx, v)}>
              <SelectTrigger className="w-full" data-testid={`home-compare-select-${idx + 1}`}>
                <SelectValue placeholder={`Select platform ${idx + 1}`} />
              </SelectTrigger>
              <SelectContent>
                {platforms.map((p) => (
                  <SelectItem key={p.id} value={p.id}>{p.name}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          ))}
        </div>
        <Button data-testid="home-compare-submit-button" onClick={onCompare} className="w-full mt-4 bg-[#111827] hover:bg-[#1F2937] rounded-lg">
          Compare Now <ArrowRight className="w-4 h-4 ml-1.5" />
        </Button>
      </div>

      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-5">
        <h3 className="font-bold text-[#111827] mb-3">Featured Resources</h3>
        <div className="space-y-3">
          {featuredResources.map((r) => (
            <Link to={r.to} data-testid={`featured-resource-${r.title.toLowerCase().replaceAll(" ", "-")}`} key={r.title} className="flex items-start gap-3 group">
              <div className="w-8 h-8 rounded-lg bg-indigo-50 flex items-center justify-center shrink-0 mt-0.5">
                <div className="w-2 h-2 rounded-full bg-indigo-500" />
              </div>
              <div>
                <p className="text-sm font-semibold text-[#111827] group-hover:text-indigo-600 transition-colors">{r.title}</p>
                <p className="text-xs text-slate-500">{r.subtitle}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
